import type { Release } from '../releases';

export default {
  id: '2026-11-03-menu-no-stubs',
  at: '2026-11-03T16:11:00Z',
  title: '«Бюджет и маржа», «Pilot» и площадка проекта открывают работающие разделы',
  modules: ['budget', 'ai', 'site'],
  items: [
    'Пункт меню «Бюджет и маржа» открывает список проектов: из него — сразу на вкладку бюджета проекта, где себестоимость, варианты, маржа и бюджет-график оплат.',
    'Пункт меню «Pilot» открывает самого помощника: вопрос, ответ по инструкциям и базе знаний со ссылками, «Помогло» или «В поддержку». Тот же Pilot — кнопкой «Спросить Pilot» в шапке.',
    'Вкладка «Площадка» в проекте показывает сводку дня и ведёт в отчёты смены, проверку отчётов и фото площадки по этому проекту.',
  ],
  why: 'Эти пункты открывали страницу с перечнем требований и надписью «появится на этапе», хотя сами разделы уже работали — найти их можно было только окольным путём.',
  link: '/budget',
} satisfies Release;
